import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// // Code (DataTable)
// import 'datatables.net-buttons-bs4/js/buttons.bootstrap4';
// import 'datatables.net-buttons/js/buttons.html5';
// import 'datatables.net-buttons/js/buttons.print';
// import 'datatables.net-buttons/js/buttons.colVis';
// import 'datatables.net-responsive/js/dataTables.responsive';

// // Buttons / Stryles (DataTable)
// import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';

//#region old code

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

//#endregion old code

ReactDOM.render(
  <App />,
  document.getElementById('root')
);